<template>
    <td-dialog :title="$t(title)" :before-close="menuDialogClose" :visible.sync="dialogMenuVisible" width="630px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formMenuInfo" ref="formMenuInfo" :label-position="labelPosition" :label-width="formLabelWidth" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.MENU_NAME')" prop="menuName">
                        <td-input v-model="formMenuInfo.menuName" :maxlength="50"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.MENU_URL')" prop="menuUrl">
                        <td-input v-model="formMenuInfo.menuUrl"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.MENU_ICON_URL')" prop="menuIconUrl">
                        <el-popover placement="top-start" width="200" trigger="click" :content="$t('common.MENU_ICON_URL_EXPLAIN')">
                            <td-input v-model="formMenuInfo.menuIconUrl" slot="reference"></td-input>
                        </el-popover>
                    </el-form-item>
                    <el-form-item :label="$t('common.MENU_ICON')" prop="menuIcon">
                        <td-input v-model="formMenuInfo.menuIcon" :maxlength="50"></td-input>
                        <p class="spanMessage">
                            {{ $t('common.MENU_ICON_MESSAGE') }}
                        </p>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.MENU_SORT')" prop="menuSort">
                        <td-inputNumber v-model="formMenuInfo.menuSort" :min="1" :max="65535"></td-inputNumber>
                    </el-form-item>
                    <el-form-item :label="$t('common.SUPERIOR_MENU')" prop="parentMenuId">
                        <td-tree-select
                            v-model="formMenuInfo.parentMenuId"
                            :treeList="treeList"
                            ref="treeSelect"
                            nodeKey="menuId"
                            :lazyloading="false"
                            :defaultProps="defaultProps"
                            :multiple="false"
                            @isChosen="isChosen"
                        ></td-tree-select>
                    </el-form-item>
                    <el-form-item :label="$t('common.PLUGIN_NAME')" prop="pluginName">
                        <td-input v-model="formMenuInfo.pluginName" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formMenuInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="menuDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import menuApi from '../assets/api.js';
export default {
    props: ['title', 'dialogMenuVisible', 'editItem', 'isAddData', 'selectOptions'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
        this.treeList = this.selectOptions;
    },
    // 定义变量
    data() {
        return {
            labelPosition: 'right',
            formLabelWidth: '85px',
            treeList: [],
            defaultProps: { children: 'children', label: 'menuName', id: 'menuId', imgName: 'menuIcon' },
            // menu表单信息
            formMenuInfo: {
                menuName: '',
                menuUrl: '',
                parentMenuId: [],
                menuSort: '1',
                pluginName: '',
                menuIcon: '',
                moduleId: 'user_base_module',
                moduleIdChk: false,
                menuIconUrl: ''
            },
            moduleIdDiabled: true,
            // 对表单进行数据验证
            rules: {
                menuName: [
                    { required: true, message: this.$t('error.ERROR_INPUT_MENU_NAME'), trigger: 'change' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'change' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                menuIcon: [{ pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }],
                menuUrl: [{ pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_MENU_URL') }],
                menuIconUrl: [{ pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_MENU_ICON_URL') }],
                parentMenuId: [{ required: true, message: this.$t('error.ERROR_INPUT_SUPERIOR_MENU'), trigger: 'change' }],
                menuSort: [{ required: true, message: this.$t('error.ERROR_INPUT_MENU_SORT'), trigger: 'change' }],
                pluginName: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'change' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ]
            },
            saveLoading: false
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formMenuInfo.menuName = this.editItem.menuName;
            this.formMenuInfo.menuUrl = this.editItem.menuUrl;
            this.formMenuInfo.menuSort = this.editItem.menuSort;
            this.formMenuInfo.menuIcon = this.editItem.menuIcon;
            this.formMenuInfo.describe = this.editItem.describe;
            this.formMenuInfo.pluginName = this.editItem.pluginName;
            this.formMenuInfo.menuIconUrl = this.editItem.menuIconUrl;
            /* 获取父级菜单对象 */
            this.getParentMenuData(this.selectOptions);
        },
        getParentMenuData(menuData) {
            for (var i = 0; i < menuData.length; i++) {
                if (menuData[i].menuId == this.editItem.parentMenuId) {
                    this.formMenuInfo.parentMenuId = [menuData[i]];
                    break;
                } else if (menuData[i].children.length > 0) {
                    this.getParentMenuData(menuData[i].children);
                }
            }
        },
        isChosen(data) {
            if (!this.isAddData && data.menuId == this.editItem.menuId) {
                this.$message({
                    showClose: true,
                    message: this.$t('error.PLEASE_CHECK_OTHER'),
                    type: 'warning'
                });
                this.$refs.treeSelect.isSelect(false);
            }
        },
        // 提交数据
        submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let parentMenuId = _this.$refs.treeSelect.getSelectedNodes().menuId;
                    let content = {
                        menuName: this.formMenuInfo.menuName,
                        menuUrl: this.formMenuInfo.menuUrl,
                        parentMenuId: parentMenuId,
                        menuSort: this.formMenuInfo.menuSort,
                        menuIcon: this.formMenuInfo.menuIcon,
                        describe: this.formMenuInfo.describe,
                        pluginName: this.formMenuInfo.pluginName,
                        moduleId: this.formMenuInfo.moduleId,
                        menuIconUrl: this.formMenuInfo.menuIconUrl
                    };
                    this.saveLoading = true;
                    if (this.isAddData) {
                        menuApi.insertMenuInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({
                                    showClose: true,
                                    message: response.data.statusMessage,
                                    type: 'error'
                                });
                                this.$log.error('dialogMenuinfo/insertMemuInfo', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.saveLoading = false;
                            this.$message({
                                showClose: true,
                                message: this.$t('common.ADD_SUCCESS'),
                                type: 'success'
                            });
                            this.menuDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    } else {
                        content.menuId = this.editItem.menuId;
                        menuApi.updateMenuInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({
                                    showClose: true,
                                    message: response.data.statusMessage,
                                    type: 'error'
                                });
                                this.$log.error('dialogMqinfo/updateMqInfo', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.saveLoading = false;
                            this.$message({
                                showClose: true,
                                message: this.$t('common.MODIFY_SUCCESS'),
                                type: 'success'
                            });
                            this.menuDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    }
                }
            });
        },
        checkboxChange(value) {
            if (value) {
                this.moduleIdDiabled = false;
            } else {
                this.moduleIdDiabled = true;
            }
        },
        // 关闭窗口之前需要调用的方法
        menuDialogClose() {
            this.$emit('menuDialogClose');
            this.$refs['formMenuInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.spanMessage {
    font-size: 12px;
    color: #f56c6c;
}
</style>
